'use strict';

class UserLoginService {
	constructor($http, $q, $rootScope, $location){
		this.$http      = $http;
		this.$q         = $q;
		this.$rootScope = $rootScope;
		this.$location  = $location;

	}

	verifyLogin(postData){
		var deferred = this.$q.defer();
		var option = {
			method:'POST',
			url:'/login',
			headers:{'Content-Type':'application/json'},
			data:postData
		};
		this.$http(option).success(function(data){
			if(data){
				deferred.resolve(data.Data);
			}
			else {
				deferred.reject(data.Error);
			}
		}).error(function(err){
			deferred.reject(err);
		});
		return deferred.promise;
	}
	checkLogin(){
		var deferred = this.$q.defer();
		var option = {
			method:'GET',
			url:'/checkLogin',
			headers:{'Content-Type':'application/json'}
		};
		this.$http(option).success(function(data){
			if(data){
				deferred.resolve(data.Data);
			}
			else {
				deferred.reject(data.Error);
			}
		}).error(function(err){
			deferred.reject(err);
		});
		return deferred.promise;
	}
	logOut(){
		var deferred = this.$q.defer();
		var option = {
			method:'GET',
			url:'/logout',
			headers:{'Content-Type':'application/json'}
		};
		this.$http(option).success(function(data){
			if(data){
				deferred.resolve(data.Data);
			}
			else {
				deferred.reject(data.Error);
			}
		}).error(function(err){
			deferred.reject(err);
		});
		return deferred.promise;
	}


}
UserLoginService.$inject = ['$http', '$q', '$rootScope', '$location'];
export default UserLoginService;


// WEBPACK FOOTER //
// ./src/app/modules/authentication/user-login.service.js